exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--11tacSJ1N237bAhiaVKB7_ {\n  display: flex;\n  align-items: end;\n  padding: 0 0 1.25rem 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"toolbarContainer": "care-team-tasks--11tacSJ1N237bAhiaVKB7_",
	"toolbarContainer": "care-team-tasks--11tacSJ1N237bAhiaVKB7_"
};